import styled, { css } from 'styled-components';
import { Width } from '../../types';

export const SelectFieldContainer = styled.button<{ width?: Width }>`
  display: flex;
  align-items: center;
  padding: var(--spacing-s);
  background: var(--color-interface-neutral-light);
  border: 1px solid var(--color-interface-layout-normal);
  border-radius: var(--radius-4);
  width: ${(p) => p.width ?? 'min-content'};
  gap: var(--spacing-xxs);
  color: var(--color-interface-secondary-normal);
  cursor: pointer;
  margin: calc(var(--spacing-xxs) * 2);
  transition: var(--transition-fast);
  overflow: hidden;
  justify-content: space-between;

  > svg {
    flex-shrink: 0;
  }

  > p {
    color: var(--color-interface-secondary-normal);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &:focus-within,
  &:hover {
    padding: var(--spacing-m);
    border-color: var(--color-interface-secondary-normal);
    box-shadow: var(--elevation-soft);
    margin: unset;
    gap: calc(var(--spacing-xxs) * 2);
    width: ${(p) =>
      p.width ? `calc(${p.width} + var(--spacing-s))` : 'min-content'};
  }

  &:active {
    padding: var(--spacing-m);
    border-color: var(--color-interface-secondary-normal);
    box-shadow: none;
  }

  &:disabled {
    pointer-events: none;
    color: var(--color-interface-layout-darker);

    > p {
      color: var(--color-interface-layout-darker);
    }
  }
`;
